import axios from "axios";

const getLatestSuccessfulRelease = async (branchName, envVariables) => {
  try {
    const releasesResponse = await axios.get(
      `https://vsrm.dev.azure.com/${envVariables.REACT_APP_AZDEVOPS_ORG}/${envVariables.REACT_APP_AZDEVOPS_PROJ}/_apis/release/deployments?definitionEnvironmentId=${envVariables.REACT_APP_AZDEVOPS_ENVIRONMENT_ID}&deploymentStatus=succeeded&$top=1`,
      {
        headers: {
          Authorization: `Basic ${btoa(":" + envVariables.REACT_APP_AZDEVOPS_PAT)}`,
        },
      }
    );

    return {
      releaseNumber: releasesResponse.data.value[0].release.name,
      branchName: releasesResponse.data.value[0].releaseEnvironment.name,
      lastDeploymentDate: releasesResponse.data.value[0].lastModifiedOn,
    };
  } catch (error) {
    console.error("Error fetching latest successful release:", error);
    return null;
  }
};

export default getLatestSuccessfulRelease;
